import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";

interface ProfileHeaderProps {
  isFormVisible: boolean;
  onToggleForm: () => void;
}

export const ProfileHeader = ({ isFormVisible, onToggleForm }: ProfileHeaderProps) => {
  if (!isFormVisible) {
    return (
      <div className="space-y-6 bg-card p-6 rounded-lg shadow-sm">
        <div className="flex flex-wrap gap-2">
          <Button onClick={onToggleForm}>Ändra uppgifter</Button>
          <Button variant="outline" asChild>
            <a href="/dokument/oversikt-for-gruppledare.pdf" target="_blank" rel="noopener noreferrer">
              <FileText className="mr-2 h-4 w-4" />
              Översikt
            </a>
          </Button>
          <Button variant="outline" asChild>
            <a href="/dokument/lathund-for-hemsidan.pdf" target="_blank" rel="noopener noreferrer">
              <FileText className="mr-2 h-4 w-4" />
              Lathund för hemsidan
            </a>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h2 className="text-xl font-medium">Profilinformation</h2>
    </div>
  );
};